import React from 'react';
import {useTranslation} from 'react-i18next';

import {Icon} from '@atoms';
import {useModal} from '@hooks';
import {Workday} from '@lib/store/src/data/timeslots/apiTypes';
import {Button} from '@molecules';
import {pxToRem} from '@utils';

interface Props {
  workday?: Workday;
  isEditing: boolean;
  isSavingDisabled?: boolean;
  setIsEditing: React.Dispatch<React.SetStateAction<boolean>>;
  isMutating: boolean;

  onDelete: () => void;
  onSave: () => void;
}

export const WorkdayDetailsModalBottom = ({
  workday,
  isEditing,
  isSavingDisabled,
  setIsEditing,
  isMutating,
  onDelete,
  onSave,
}: Props) => {
  const {closeModal} = useModal();
  const {t} = useTranslation();

  // Editing existing workday
  if (workday && !isEditing) {
    return (
      <div className="grid grid-cols-2 gap-5 px-5">
        <Button
          button="secondary"
          onClick={() => setIsEditing((prev) => !prev)}>
          <Icon
            icon="pencil"
            size={pxToRem(15)}
          />
          {t('translation:Edit')}
        </Button>
        <Button
          button="secondary destructive"
          loading={isMutating}
          onClick={onDelete}>
          <Icon
            icon="trash"
            size={pxToRem(15)}
            color="currentColor"
          />
          {t('translation:Delete')}
        </Button>
      </div>
    );
  }

  // Creating new workday
  return (
    <div className="grid grid-cols-2 gap-5 px-5">
      <Button
        button="secondary"
        onClick={isEditing ? () => setIsEditing((prev) => !prev) : closeModal}>
        {t('translation:Cancel')}
      </Button>
      <Button
        button="primary"
        loading={isMutating}
        disabled={isSavingDisabled}
        onClick={onSave}>
        {isEditing ? t('translation:Save') : t('translation:Book')}
      </Button>
    </div>
  );
};
